import React from 'react';
import { Icon, Image, Label } from 'react-frontier';
import { EventDateList, EventStatusType } from '../SiteClasses';
import { Link } from 'react-router-dom';
import moment from 'moment';
import classNames from 'classnames';

interface EventCardProps {
	event: EventDateList;
	onClick?: () => void;
}

var EventCard = (props: EventCardProps)=>{
	var e = props.event;

	var EventItem = (
		<div 
			className={classNames("ar event-card", { hidden: e.status_id === EventStatusType.NOT_OPERATED })} 
			onClick={e.status_id !== EventStatusType.OPERATING && 
				e.status_id !== EventStatusType.PROMOTER_OPERATED && 
				e.status_id !== EventStatusType.POSTPONED && 
				e.status_id !== EventStatusType.CANCELLED ? props.onClick : undefined}
		>
			<div className="poster">
				<Image src={e.poster_url || '/placeholder.png'} className='poster-image' fallback='/placeholder.png' />
				<div className="time">
					<Icon name='clock' />
					<div>{moment.unix(e.date).format('HH:mm')}</div>
				</div>
			</div>
			<div className="content">
				<div className="header">
					<div className="name">{e.event_name}</div>
					<Label className="badge" color='black'>
						<Icon name='ticket' /> {(e.tickets_sold ?? 0) + (e.tickets_free ?? 0)}
					</Label>
				</div>
				<div className="details">
					<div className="item">
						<Icon name='user-tie' />
						<div className="text">{e.promoter_name}</div>
					</div>
					<div className="item">
						<Icon name='map-marker-alt' />
						<div className="text">{e.city}</div>
					</div>
					{e.closed ? (
						<Label className="badge" color='red'>
							<Icon name='lock' /> Cerrado
						</Label>
				) : e.status_id === EventStatusType.OPERATING ? (
					<div className="item coordinator">
						<Icon name='user-shield' />
						{e.user_coordinator ? (
							<div className="text">{e.user_coordinator_name}</div>
						) : (
							<Label color='blue' size='small'>Sin coordinador</Label>
						)}
					</div>
			) : e.status_id === EventStatusType.PROMOTER_OPERATED ? (
				<Label className="badge" color='blue'>
					<Icon name='handshake' /> Operado por promotor
				</Label>
				) : e.status_id === EventStatusType.NOT_OPERATED ? (
					<Label className="badge" color='transparent' style={{ backgroundColor: '#6c757d', color: 'white' }}>
						<Icon name='ban' /> No operado
					</Label>
				) : e.status_id === EventStatusType.POSTPONED ? (
					<Label className="badge" color='orange'>
						<Icon name='clock' /> Pospuesto
					</Label>
				) : e.status_id === EventStatusType.CANCELLED ? (
					<Label className="badge" color='red'>
						<Icon name='times-circle' /> Cancelado
					</Label>
				) : (
					<Label className="badge" color='orange'>
						<Icon name='exclamation-triangle' /> No configurado
					</Label>
				)}
				</div>
			</div>
		</div>
	);
	if(e.status_id !== EventStatusType.OPERATING && e.status_id !== EventStatusType.PROMOTER_OPERATED && e.status_id !== EventStatusType.POSTPONED && e.status_id !== EventStatusType.CANCELLED){
		return <React.Fragment>{EventItem}</React.Fragment>;
	}else{
		return(
			<Link to={`/events/${e.date_id}`}>
				{EventItem}
			</Link>
		);
	}
}

export default EventCard;
